import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeComponent} from './home.component';
import {HomeRoutingModule} from './home-routing.module';
import {ReactiveFormsModule} from '@angular/forms';
import {NewdelegationComponent} from './newdelegation/newdelegation.component';
import {CommonDomainModule} from 'common-domain';
import {RecoverUserNameInitComponent} from './recover-user-name-init/recover-user-name-init.component';
import {AcTcConfirmationComponent} from './ac-tc-confirmation/ac-tc-confirmation.component';
import {SignUpComponent} from "./sign-up/sign-up.component";
import {CreatePasswordComponent} from "./sign-up/create-password/create-password-component";
import {ResetPasswordInitComponent} from "./reset-password-flow/reset-password-init/reset-password-init.component";
import {ResetPasswordCompleteComponent} from "./reset-password-flow/reset-password-complete/reset-password-complete.component";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ChangeExpiredPasswordComponent} from './change-expired-password/change-expired-password.component';
import { LoadingPageComponent } from './loading-page/loading-page.component';
import {
  TermsAndPrivacyAcknowledgmentComponent
} from "./terms-and-privacy-acknowledgment/terms-and-privacy-acknowledgment.component";
import { MfaLoginVerificationCodeComponent } from './mfa-login-verification-code/mfa-login-verification-code.component';
import { ResetPasswordMfaComponent } from './reset-password-flow/reset-password-mfa/reset-password-mfa.component';

@NgModule({
  imports: [
    CommonModule,
    CommonDomainModule,
    HomeRoutingModule,
    ReactiveFormsModule,
    FontAwesomeModule
  ],
  exports: [
    CreatePasswordComponent,
    TermsAndPrivacyAcknowledgmentComponent
  ],
  declarations: [HomeComponent, NewdelegationComponent, RecoverUserNameInitComponent, AcTcConfirmationComponent, SignUpComponent, CreatePasswordComponent, ResetPasswordInitComponent, ResetPasswordCompleteComponent, ChangeExpiredPasswordComponent, LoadingPageComponent, TermsAndPrivacyAcknowledgmentComponent, MfaLoginVerificationCodeComponent, ResetPasswordMfaComponent]
})
export class HomeModule {
}
